import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";

class Streams extends React.Component {

	renderStreamStatus() {
		switch (this.props.stream.type) {
			case 'stream.video.twilio.room.go':
				return <span className="wcStreamStatus wcStreamOnGoing wcAnimation wcAnimationFlashSlow" />;
			default:
				return 'Unsupported stream';
		}
	}

	render() {
		if (!this.props.stream) {
			return null;
		}

		return this.renderStreamStatus();
	}
}

Streams.propTypes = {
	channel: PropTypes.object.isRequired
};

export default connect(
	(state, ownProps) => ({
		stream: state.ui.streams.find( stream => stream.channel && stream.channel.id === ownProps.channel.id )
	})
)(Streams);